import * as DropdownMenu from '@radix-ui/react-dropdown-menu'

import { DropdownTriangle, RemoveUser } from '@/assets/icons'
import { MenuContent, MenuItemGroup } from '@/components/menu/MenuContent'
import { MenuItem } from '@/components/menu/MenuItem'

interface MemberRowProps {
  displayName: string
  email: string
  isOwnerRow: boolean
  isCurrentUser: boolean
  canRemove: boolean
  onRemove: () => void
}

function memberInitials(displayName: string): string {
  return displayName
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word[0])
    .join('')
    .toUpperCase()
}

export function MemberRow({ displayName, email, isOwnerRow, isCurrentUser, canRemove, onRemove }: MemberRowProps) {
  const roleLabel = isOwnerRow ? 'Owner' : 'Contributor'

  return (
    <div className="flex items-center gap-3 border-b border-brand-neutral-200 px-6 py-2">
      <div className="flex size-8 shrink-0 items-center justify-center rounded-full bg-brand-neutral-200 font-medium text-brand-neutral-700">
        {memberInitials(displayName)}
      </div>
      <div className="min-w-0 flex-1">
        <p className="truncate text-sm font-medium text-brand-neutral-950">{isCurrentUser ? `${displayName} (you)` : displayName}</p>
        <p className="truncate text-xs text-brand-neutral-800">{email}</p>
      </div>
      {canRemove ? (
        <DropdownMenu.Root>
          <DropdownMenu.Trigger
            aria-label={`Manage ${displayName}`}
            className="flex shrink-0 items-center rounded-md py-1 pl-1.5 pr-0.5 text-xs font-medium text-brand-neutral-800 hover:bg-brand-neutral-100 focus:outline-none data-[state=open]:bg-brand-neutral-100"
          >
            {roleLabel}
            <DropdownTriangle className="size-4" aria-hidden />
          </DropdownMenu.Trigger>
          <MenuContent align="end" sideOffset={4} className="min-w-[200px]">
            <MenuItemGroup>
              <MenuItem label="Remove member" variant="destructive" icon={RemoveUser} onSelect={onRemove} />
            </MenuItemGroup>
          </MenuContent>
        </DropdownMenu.Root>
      ) : (
        <span className="shrink-0 px-1.5 py-1 text-xs font-medium text-brand-neutral-800">{roleLabel}</span>
      )}
    </div>
  )
}
